import { components, MenuProps } from 'react-select';
import styled from 'styled-components';

export const ContextSwitchMenu = styled(components.Menu)<MenuProps>`
    && {
        box-shadow: none;
        margin-top: 54px;
    }
`;
